<template>
  <b-card>
    <b-card class="multi-card">
      <div slot="header">
        <b-row>
          <b-col md="8">
            <h5>{{ $t('CONFIGURED.PROCESS_TYPE') }}</h5>
          </b-col>
          <b-col md="4">
            <div class="float-right add-field-btn">
              <b-button size="sm" variant="secondary" @click="handleSubscribeModal" :disabled="unsubscribedCategories.length === 1">
                <i class="fa fa-plus"></i><span> {{ $t('COMMON.SUBSCRIBE') }} </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="timeline-div">
        <ul class="timeline timeline-horizontal">
          <div class="flex-container">
            <li class="timeline-item" v-for="(category, index) in accountCategories" :key="category">
              <div class="timeline-badge bg-primary"><strong>{{index + 1}}</strong></div>
              <div class="timeline-panel role-panel"><p>{{ category | titlize }}</p>
                <b-dropdown no-caret class="panel-option">
                  <template slot="button-content">
                    <div><i class="fa fa-ellipsis-v"></i></div>
                  </template>
                  <b-dropdown-item @click="handleUnsubscribeModal(category)">{{ $t('COMMON.UNSUBSCRIBE') }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </b-card>
    <b-modal hide-header-close centered :title="$t('CONFIGURED.SUBSCRIBE_MODAL')" ref="subscribeModal" :ok-title="$t('COMMON.SUBSCRIBE')" :cancel-title="$t('COMMON.CANCEL')" @ok="subscribeNewCategory" ok-variant="secondary" cancel-variant="light" @hidden="hideSubscribeModal">
      <b-card class="mb-0">
        <b-row class="form-group">
          <b-col cols="12">
           <b-form-select class="form-control" :plain="true" v-model="selectedCategory" :options="unsubscribedCategories"></b-form-select>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <b-modal hide-header-close centered :title="$t('CONFIGURED.UNSUBSCRIBE_MODAL')" ref="unsubscribeModal" :ok-title="$t('COMMON.UNSUBSCRIBE')" :cancel-title="$t('COMMON.CANCEL')" @ok="unsubscribeCategory" ok-variant="secondary" cancel-variant="light" @hidden="hideUnSubscribeModal">
      <b-card class="mb-0">
        <b-row class="form-group">
          <b-col cols="12">
            <p>Are you sure want unscubscribe '<strong>{{ selectedCategory | capitalize }}</strong>' ?</p>
            <p>This will no longer be available for processing documents.</p>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </b-card>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      accountCategories: [],
      unsubscribedCategories: [{ text: 'Select a process type', value: null }],
      selectedCategory: null
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isSuperAdmin'])
  },
  created () {
    this.fetchCategories()
  },
  methods: {
    fetchCategories () {
      Vue.axios.get('/settings/process_types/account_categories', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.accountCategories = res.data.account_categories
          this.unsubscribedCategories = this.unsubscribedCategories.concat(res.data.unsubscribed_categories.map(category => { return { text: category, value: category } }))
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    handleSubscribeModal () {
      this.$refs.subscribeModal.show()
    },
    handleUnsubscribeModal (category) {
      this.selectedCategory = category
      this.$refs.unsubscribeModal.show()
    },
    hideSubscribeModal () {
      this.selectedCategory = null
      this.$refs.subscribeModal.hide()
    },
    hideUnSubscribeModal () {
      this.selectedCategory = null
      this.$refs.unsubscribeModal.hide()
    },
    subscribeNewCategory (event) {
      event.preventDefault()
      if (this.selectedCategory) {
        let payload = { category: this.selectedCategory }
        Vue.axios.post('/settings/process_types/subscribe', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.hideSubscribeModal()
            if (res.data.success) {
              let subscribedCategory = res.data.category
              this.accountCategories = this.accountCategories.slice().concat([subscribedCategory])
              this.unsubscribedCategories = this.unsubscribedCategories.filter(category => { return category.value !== subscribedCategory })
              Vue.toasted.show(this.$t('CONFIGURED.SUBSCRIBE_PT'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            this.hideSubscribeModal()
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    unsubscribeCategory (event) {
      event.preventDefault()
      if (this.selectedCategory) {
        let payload = { category: this.selectedCategory }
        Vue.axios.post('/settings/process_types/unsubscribe', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.hideUnSubscribeModal()
            if (res.data.success) {
              let unsubscribedCategory = res.data.category
              this.accountCategories = this.accountCategories.slice().filter(category => { return category !== unsubscribedCategory })
              this.unsubscribedCategories = this.unsubscribedCategories.slice().concat([{ text: unsubscribedCategory, value: unsubscribedCategory }])
              Vue.toasted.show(this.$t('CONFIGURED.UNSUBSCRIBE_PT'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            this.hideUnSubscribeModal()
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: #ebeff3;
    border-radius: 10px;
  }
  .card-header {
    background: #f7f7f7;
  }
  .timeline-div {
    display: inline-block;
    width: 100%;
    overflow-y: auto;
    background-color: #f7f7f7;
    padding-top: 35px;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .timeline,
  .timeline-horizontal {
    list-style: none;
    padding: 20px;
    position: relative;
  }
  .timeline:before {
    top: 40px;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 5px;
    background-color: #5b648f;
    margin-left: -1.5px;
  }
  .timeline .timeline-item {
    margin-bottom: 20px;
    position: relative;
  }
  .timeline .timeline-item:before,
  .timeline .timeline-item:after {
    content: "";
    display: table;
  }
  .timeline .timeline-item:after {
    clear: both;
  }
  .timeline .timeline-item .timeline-badge {
    color: #fff;
    width: 60px;
    height: 60px;
    line-height: 52px;
    font-size: 18px;
    text-align: center;
    position: absolute;
    top: 18px;
    left: 50%;
    margin-left: -25px;
    background-color: #7c7c7c;
    border: 5px solid #5b648f;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    cursor: move;
  }
  .timeline .timeline-item .timeline-badge.primary {
    background-color: #1f9eba;
  }
  .timeline .timeline-item .timeline-panel {
    position: relative;
    width: 20%;
    float: left;
    right: 10px;
    border: 1px solid white;
    background: #ffffff;
    border-radius: 10px;
    cursor: move;
    padding: 5px;
    max-width: 15em;
  }
  .timeline .timeline-item .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -16px;
    display: inline-block;
    border-top: 16px solid transparent;
    border-left: 16px solid #fff;
    border-right: 0 solid #fff;
    border-bottom: 16px solid transparent;
    content: " ";
  }
  .timeline .timeline-item .timeline-panel p {
      margin: 4px;
      text-align: center;
      font-weight: bolder;
  }
  .timeline-horizontal {
    list-style: none;
    position: relative;
    padding: 20px 0px 20px 0px;
    display: table;
    width: 100%;
  }
  .timeline-horizontal:before {
    height: 5px;
    top: auto;
    bottom: 26px;
    right: 0;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item {
    display: table-cell;
    min-width: 200px;
    float: none !important;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 auto;
    vertical-align: bottom;
  }
  .timeline-horizontal .timeline-item .timeline-panel {
    top: auto;
    bottom: 36px;
    display: inline-block;
    float: none !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item .timeline-panel:before {
    top: auto;
    bottom: -16px;
    left: 76px !important;
    right: auto;
    border-right: 16px solid transparent !important;
    border-top: 16px solid #fff !important;
    border-bottom: 0 solid #fff !important;
    border-left: 16px solid transparent !important;
  }
  .timeline-horizontal .timeline-item:before,
  .timeline-horizontal .timeline-item:after {
    display: none;
  }
  .timeline-horizontal .timeline-item .timeline-badge {
    top: auto;
    bottom: 0px;
  }
  ul li.timeline-item{
   max-width: 2em;
  }
  .multi-card .card-body{
    padding: 1.25em 0 0 0;
  }
  .multi-card{
    margin-bottom:0;
  }
  .flex-container {
    display: flex;
    justify-content: center;
  }

  .timeline {
    margin: 0;
  }
  .button-style {
    font-size: 1rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    border-radius: 16px;
  }

  .button-style:nth-child(1) {
    margin-right: .5rem;
  }

  .button-style:nth-child(2) {
    margin-left: .5rem;
  }

  .panel-option:hover {
    cursor: pointer;
  }

  .panel-option {
    display: inline;
    position: absolute;
    right: 0;
    padding: 0 0.2rem;
  }

  .timeline-item .timeline-panel.role-panel {
    display: flex;
    justify-content: center;
  }
</style>
<style>
  .panel-option button {
    color: red;
    background-color: white;
  }
  .panel-option button ,.panel-option button:active:focus,
  .panel-option button:hover, .panel-option button:active,
  .panel-option .btn:not(:disabled):not(.disabled):active{
    color: inherit;
    background-color: inherit;
    border: none;
    box-shadow: none;
    padding: 5px 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/processType.vue